import React, { useEffect, useState } from 'react'
import { View, StyleSheet, ScrollView, Text, RefreshControl } from 'react-native'

import client, { useClient } from '@sart/client'
import { useContent } from '@sart/content'
import { adaptive, colors, typography } from '@sart/styles'
import {
	CustomerNotification,
	Space 
} from '@sart/components'
import { updateNotifications, updateNotificationStatus, getNotificationType } from '@sart/utilities'
import AppConfig from '../Configuration/AppConfig'

export default function Inbox(props) {
	const { navigation } = props

  const content = useContent()
	const [error,setError] = useState(false)

	useEffect(() => {
    loadNotifications()
  }, [])

	const {
    cache: {
      userId,
			notifications,
			loading,
			language
    } = {}
  } = useClient()

	async function loadNotifications() {
		setError(false)
		try {
			updateNotifications(userId)
		} catch (error){
			console.log(error)
			setError(true)
		}
	}

	async function markAsRead(notification) {
		// We need to update the PAC (Page Access Control) for this notification to be 'seen'
		updateNotificationStatus(notification, 'seen')
	}

	async function displayNotification(notification) {
		// Need to look for Page Product Pairings for the notification
		var pageProductPairings = await client.callApi('contentCms','getPageProductPairings',[1,notification.pageId])
		var basketRefId = ''
		if(pageProductPairings !== undefined && pageProductPairings.length > 0) {
			// There are page product pairings, set up a confirmed basket and pass it to the navigation
			// Create basket
			var basket = await client.createBasket()
			var productLegacyIds = ''
			for(var i = 0; i < pageProductPairings.length; i++) {
				//Get the product(s) from the Page Product Pairing and add them to the basket
				productLegacyIds = productLegacyIds + pageProductPairings[i].productLegacyId
				if(i + 1 < pageProductPairings.length) {
					productLegacyIds+= ','
				}
			}
			var products = await client.callApi('catalog','getProducts',[client.cache.catalogId, {productLegacyIds, includeExpired: true}])
			for(var i=0; i < products.length; i++) {
				basket = await client.addServiceProductToBasket(basket,products[i])
				for(var j = 0; j < pageProductPairings.length; j++) {
					if(products[i].productLegacyId === pageProductPairings[j].productLegacyId) {
						pageProductPairings[j].productId = products[i].productId
					}
				}
			}
			// Add the page product pairings to the notification
			notification.ppp = pageProductPairings
			if(notification.href !== undefined && notification.href) {
				//Only Confirm the basket and create payment method if it is a questionnaire
				basket = await client.confirmBasket(basket)
				//Create the payment
				basket = await client.payForBasketWithHostedPayment(basket, AppConfig.customerNotificationHostedGateway)
				basketRefId = basket.basketRefId
			}
		}
		const navParams = {
			notification,
			basketRefId
		}
		navigation.navigate('DisplayNotification',navParams)
		
	}
	

	return (
		<ScrollView style={styles.container}
			refreshControl={
				<RefreshControl
					refreshing={loading}
					onRefresh={loadNotifications}
				/>
			}
			showsVerticalScrollIndicator={false}
		>
			<Space height={32} />
		{ notifications !== undefined && notifications.length > 0 && !error && notifications.map(notification => {
			return (
				<View>
					<CustomerNotification
						notification = {notification}
						disabled = {loading}
						language = {language}
						markAsRead = {() => markAsRead(notification)}
						displayNotification = {() => displayNotification(notification)}
						backgroundColor={colors.srGreen}
						injectedContent={content}
					/>
					<Space height={24} />
				</View>)
		})}
		{ notifications !== undefined && notifications.length === 0  && !error &&
			// No errors and no notifications to show 
			<View>
				<Text style={styles.noNotifications}>{content.inbox.noNotifications}</Text>
			</View>
		}
		{ error && 
			// Error loading the notifications
			<View>
				<Text style={styles.noNotifications}>{content.inbox.notificationError}</Text>
			</View>
		}
		</ScrollView>
	)
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
		backgroundColor:colors.white,
    ...adaptive.wrapperPadding
  },
	noNotifications: {
		textAlign:'center',
		fontSize:16,
		color:colors.feature,
		...typography.bold
	}
})